import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { Controller, UseFormReturn } from 'react-hook-form'
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import InputLabel from 'components/ui/forms/field/input-label/InputLabel'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { FormValues } from '../constants'
import styles from './Sence.module.scss'

export type SenceProps = { form: UseFormReturn<FormValues> }

export const Sence = ({ form: { control, watch } }: SenceProps) => {
  const t = useTranslationRankmi({
    prefix: 'configuration.general.integrations.sence',
  })
  const senceState = watch('senceState')

  return (
    <div className="mt-2">
      <Form>
        <InputLabel
          className="mb-0"
          label={
            <>
              {t('title')}
              <CommonToolTip text={t('tooltip')} position="right">
                <FontAwesomeIcon icon={faInfoCircle} className={`ml-2`} />
              </CommonToolTip>
            </>
          }
        ></InputLabel>
      </Form>
      <div
        className={classNames(styles.senceForm, !senceState && styles.hidden)}
      >
        <Controller
          name="sence.token"
          control={control}
          render={({ field, fieldState }) => {
            return (
              <>
                <InputLabel label={t('forms.token.label')} />
                <Form.Control
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.value)
                  }}
                  isInvalid={!!fieldState.error}
                />
              </>
            )
          }}
        />
        <div className="mt-2">
          <Controller
            name="sence.runOtec"
            control={control}
            render={({ field, fieldState }) => {
              return (
                <>
                  <InputLabel label={t('forms.RUN.label')} />
                  <Form.Control
                    name={field.name}
                    ref={field.ref}
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value)
                    }}
                    isInvalid={!!fieldState.error}
                  />
                </>
              )
            }}
          />
        </div>
      </div>
    </div>
  )
}
